import { inject, Injectable } from "@angular/core";
import { SERVICE_STORE } from "../../domain/tokens/service-store.token";
import { Location } from "../../domain/models/location.model";
import { EVENT_BUS } from "@shared/domain/tokens/event-bus.token";
import { ServiceSelectionChangedEvent } from "@platform/event-bus/domain/events/service-selection-change.event";

@Injectable({ providedIn: 'root' })
export class SelectLocationUseCase {
  private readonly serviceStore = inject(SERVICE_STORE);
  private readonly eventBus = inject(EVENT_BUS);

  execute(location: Location): void {
    this.serviceStore.setSelection({ location });

    const { selection } = this.serviceStore.state();

    this.eventBus.publish(new ServiceSelectionChangedEvent(selection));
  }
}